import { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  fetchProduct,
  setVariant,
  addBasket,
  resetVariants,
} from "actions/productDetail";
import { fetchBasket } from "actions/basket";

let _content = null;

const ProductDetail = (props) => {
  const [productPk, setProductPk] = useState("");
  const [successModal, setSuccessModal] = useState(true);
  const { fetchProduct, setVariant, addBasket, resetVariants, fetchBasket } =
    props;

  useEffect(() => {
    if (props.success) {
      setSuccessModal(true);
    }
    let productPk = props.match.params.productPk;
    setProductPk(productPk);
    resetVariants();
    fetchProduct(productPk);
    fetchBasket();
  }, []);

  const handleChangeVariant = (searchKey, variant) => {
    let pk = productPk;
    setVariant(searchKey, variant, pk);
  };

  const addBaskets = (quantity, pk, attributes = {}) => {
    setSuccessModal(true);
    addBasket(quantity, pk, attributes);
  };

  const closeModal = () => {
    setSuccessModal(false);
  };

  return (
    _content &&
    _content({
      successModal,
      props,
      handleChangeVariant,
      addBaskets,
      closeModal,
    })
  );
};

const mapStateToProps = (state) => ({
  product: state.productDetail.product,
  variants: state.productDetail.variants,
  selected_variant: state.productDetail.selected_variant,
  pending: state.productDetail.pending,
  widgetPending: state.productDetail.widgetPending,
  widget: state.productDetail.widget,
  error: state.productDetail.error,
  basketError: state.productDetail.basketError,
  success: state.productDetail.success,
  basketItems: state.basket.basketItems,
});

const mapDispatchToProps = {
  fetchProduct,
  setVariant,
  addBasket,
  resetVariants,
  fetchBasket,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/product/detail/index.js